import { tokenExpiration } from './expiration'

type Options = {
	getToken: () => string | null | undefined
	onRenew: () => void
	onSignOut: () => void
	// Seconds before expiration renew should be run, 10 minutes
	grace?: number
	// Seconds between renew checks, 1 minute
	interval?: number
}

export const tokenRenew = ({ getToken, onRenew, onSignOut, grace = 10 * 60, interval = 1 * 60 }: Options) => {
	const intervalId = setInterval(async () => {
		const token = getToken()

		if (!token) {
			return
		}

		const expiresIn = tokenExpiration(token)

		// Has token expired?
		if (expiresIn < 0) {
			onSignOut()
			// Should token renew
		} else if (expiresIn < grace) {
			onRenew()
		}
	}, interval * 1000)

	return () => {
		clearInterval(intervalId)
	}
}
